import Component from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/uni_modules/qiun-data-charts/components/qiun-data-charts/qiun-data-charts.vue'
wx.createComponent(Component)